export default "__VITE_ASSET__f7dcfede__"